import './style.scss'
import { Button } from 'antd'
import { FC, memo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { eventTracking } from '@/libs/util'
import { HomeStore } from '../../home-state'

const AvatarCreate: FC = () => {
  const { shortcuts, shortcut_title, strategy_id } = HomeStore
  const navigate = useNavigate()
  const [hoveredItem, setHoveredItem] = useState<string | null>(null)

  const jumpTargetUrl = (l: any, index: number) => {
    eventTracking('ShortcutsClick', {
      strategy_id,
      id: l.id,
      index
    })
    if (l.btn_link) {
      navigate(l.btn_link)
    }
  }

  if (!shortcuts?.length) {
    return null
  }

  return (
    <div className="card-wrapper quickly-create">
      <div className="card-title">{shortcut_title}</div>
      <div className="card-list">
        {shortcuts?.map((l: any, index) => (
          <div
            key={l.id}
            className="list-item"
            onMouseEnter={() => setHoveredItem(l.id)}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={jumpTargetUrl.bind(this, l, index)}
          >
            <div className="img-box">
              {hoveredItem === l.id && l.video_url ? (
                <video
                  poster={l.image_url}
                  className="video-preview"
                  src={l.video_url}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                <>
                  <img className="img" src={l.image_url} />
                </>
              )}

              {l.tag_text && (
                <div
                  className="tag"
                  style={{
                    background: l.tag_bg_color || 'linear-gradient(92deg, #690799 -5.93%, #4a09d5 96.98%)',
                    color: l.tag_text_color || '#fff'
                  }}
                >
                  {l.tag_text}
                </div>
              )}
            </div>

            <div className="bottom">
              <span className="title">{l.title}</span>
              {l.btn_text && (
                <Button className="btn" type="primary">
                  {l.btn_text}
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(AvatarCreate)
